import {isEmpty} from 'lodash';
// Import Actions
import {
    CLOSE_USER_PHONE,
    EDIT_USER_PHONE,
    VERIFYING_OTP,
    SENDING_OTP,
    UPDATING_USER_PHONE,
    UPDATE_OTP_SENT_STATE,
    SHOW_HAVE_US_CALL_YOU_SUCESS_MODAL
} from '../actions/EventVerificationActions';

// Initial State
const initialState = {
    isUserPhoneNotEditable: true,
    isSendingOTP: false,
    isOTPSent: false,
    isVerifyingOTP: false,
    isUpdatingPhone: false,
    isShowVendorHaveUsCallYouSuccess: false,
};

const EventVerificationReducers = (state = initialState, action) => {

    switch (action.type) {
        case CLOSE_USER_PHONE:
            return {
                ...state,
                isUpdatingPhone: action.isUpdatingPhone,
                isUserPhoneNotEditable: action.isUserPhoneNotEditable,
            };

        case EDIT_USER_PHONE:
            return {
                ...state,
                isUserPhoneNotEditable: action.isUserPhoneNotEditable,
            };

        case VERIFYING_OTP:
            return {
                ...state,
                isVerifyingOTP: action.isVerifyingOTP,
            };

        case SENDING_OTP:
            return {
                ...state,
                isSendingOTP: action.isSendingOTP,
            };

        case UPDATING_USER_PHONE:
            return {
                ...state,
                isUpdatingPhone: action.isUpdatingPhone,
            };

        case UPDATE_OTP_SENT_STATE:
            return {
                ...state,
                isOTPSent: action.isOTPSent,
            };
        case SHOW_HAVE_US_CALL_YOU_SUCESS_MODAL:
            return {
                ...state,
                isShowVendorHaveUsCallYouSuccess: action.isShowVendorHaveUsCallYouSuccess
            }

        default:
            return state;
    }
};
export default EventVerificationReducers;